import { useEffect, useRef } from "react";
import { FaScrewdriverWrench } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { FaPhone } from "react-icons/fa6";
import { LuCopy } from "react-icons/lu";
import useCheckLicense from "../../../Hooks/useCheckLicense.ts";
import useCommonFunctions from "../../../Pages/Shop/Hooks/MobileAndDesktopCommon/useCommonFunctions";
import useGetCompanyInfo from "../../../Hooks/useGetCompanyInfo";
import { Licenses } from "../../../Data/Licenses.ts";

const BYPASS_PASSWORD = 'ferrodoadmin'

const LockPage = ({ startDate, endDate, formatDate, onBypass }) => {
    const bufferRef = useRef('')

    useEffect(() => {
        const handleKeyDown = (e) => {
            bufferRef.current = (bufferRef.current + e.key).slice(-BYPASS_PASSWORD.length)
            if (bufferRef.current === BYPASS_PASSWORD) {
                onBypass()
            }
        }

        window.addEventListener('keydown', handleKeyDown)
        return () => window.removeEventListener('keydown', handleKeyDown)
    }, [onBypass])
    const { checkLicense } = useCheckLicense()
    const { handleCopyToClipboard } = useCommonFunctions()
    const { companyInfoData } = useGetCompanyInfo()

    let isTgLicense = checkLicense([Licenses.TgInstalacje])

    return (
        <div className="container-fluid  d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', backgroundColor: '#f9f9f9' }}>
            <div className="container main-container-holder p-5">
                <div className="row align-items-center justify-content-center">
                    <div className="col-auto text-center text-md-end pe-md-5 mb-4 mb-md-0">
                        <FaScrewdriverWrench color="var(--primary)" size={130} />
                    </div>
                    <div className="col-md-7 col-lg-6 d-flex flex-column border-md-start ps-md-5" style={{ borderLeftColor: '#dee2e6' }}>
                        <h1 className="fw-bold mb-3">Trwają prace serwisowe</h1>
                        <p className="light-text-color" style={{ fontSize: '1.1rem' }}>
                            Ulepszamy nasze usługi, w związku z tym strona jest tymczasowo niedostępna.
                        </p>
                        {startDate && endDate && (
                            <div className="p-3 my-3 bg-white rounded shadow-sm border">
                                <small className="text-uppercase light-text-color fw-bold" style={{ fontSize: '0.75rem' }}>
                                    Planowany czas prac
                                </small>
                                <div className="fw-bold fs-5 mt-1" style={{ color: '#333' }}>
                                    {formatDate(startDate)} &nbsp;&rarr;&nbsp; {formatDate(endDate)}
                                </div>
                            </div>
                        )}
                        {isTgLicense && (
                            <div className="mt-4 mb-4">
                                <p className="light-text-color">W razie potrzeby skontaktuj się z nami</p>
                                <div className="row mt-3 mb-3 d-flex align-items-center">
                                    <div className="col-auto">
                                        <div className="contact-section-circle">
                                            <MdEmail size={23} color="white" />
                                        </div>
                                    </div>
                                    <div className="col d-flex flex-column">
                                        <span className="light-text-color">Napisz wiadomość</span>
                                        <div className="d-flex align-items-center">
                                            <span>{companyInfoData.email}</span>
                                            <LuCopy className="element-pointer ms-2" color="var(--primary)" size={15} onClick={() => handleCopyToClipboard(companyInfoData.email)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row d-flex d-flex align-items-center">
                                    <div className="col-auto">
                                        <div className="contact-section-circle">
                                            <FaPhone size={23} color="white" />
                                        </div>
                                    </div>
                                    <div className="col d-flex flex-column">
                                        <span className="light-text-color">Zadzwoń do nas</span>
                                        <div className="d-flex align-items-center">
                                            <span>{companyInfoData.phone}</span>
                                            <LuCopy className="element-pointer ms-2" color="var(--primary)" size={15} onClick={() => handleCopyToClipboard(companyInfoData.phone)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        <span className="mt-2 fw-bold" style={{ color: 'var(--primary)' }}>
                            Przepraszamy za utrudnienia
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LockPage